export const parsedArrayChecklist = arr => {
  const result = [];
  for (const key in arr) {
    if (Object.prototype.hasOwnProperty.call(arr, key)) {
      const [fieldType, id] = key.split('-');

      result.push({
        questionId: id,
        [fieldType === 'fieldCode' ? 'fieldCodeSelected' : 'response']: arr[key]
      });
    }
  }
  return result;
};
